/**
 * @desc 导入运营调整信息模板下载
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/srm/procurementOrder/importOperationAdjustmentTemplate`, {
      method: "GET",

      ...options,
    }),
  );
}
